module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0054.jpg?v=c7e0a0f5";